// Lectures recalculées sur l'appareil (stock, répartition, état des commandes…).
// Chaque résolveur reçoit `{ chemin, parametres }` et rend la réponse que le
// serveur aurait rendue, ou `undefined` quand il ne sait pas la calculer.
const resolveurs = {};

export const enregistrerResolveur = (chemin, fonction) => {
  resolveurs[chemin] = fonction;
};

export const resolveursLocaux = () => resolveurs;

// Résolveurs par motif d'adresse (ex.: /orders/:id/available-trucks).
const resolveursParMotif = [];
export const enregistrerResolveurMotif = (motif, fonction) => {
  resolveursParMotif.push({ motif, fonction });
};
export const resolveurPour = (chemin) => {
  if (resolveurs[chemin]) return resolveurs[chemin];
  for (const { motif, fonction } of resolveursParMotif) {
    const correspondance = motif.exec(chemin);
    if (correspondance) return (contexte) => fonction({ ...contexte, correspondance });
  }
  return null;
};

// Corrections appliquées à une liste reconstruite (totaux qui dépendent des
// lignes saisies sur l'appareil).
const ajusteurs = {};
export const ajusterListe = (kind, fonction) => {
  ajusteurs[kind] = fonction;
};
export const ajusteurDeListe = (kind) => ajusteurs[kind] || null;

// Filtres d'une liste qui suivent les règles du serveur (ex.: les groupes
// d'étapes des trajets), quand comparer chaque paramètre au champ du même nom
// ne suffit pas. Reçoit `(lignes, parametres)` et rend les lignes retenues.
const filtres = {};
export const filtrerListe = (kind, fonction) => {
  filtres[kind] = fonction;
};
export const filtreDeListe = (kind) => filtres[kind] || null;

// En-têtes de comptage recalculés sur la liste complète (ex.: camions propres / loués).
const ajusteursEntetes = {};
export const ajusterEntetes = (kind, fonction) => {
  ajusteursEntetes[kind] = fonction;
};
export const ajusteurDEntetes = (kind) => ajusteursEntetes[kind] || null;
